/* Besucher aus Google Shopping (Anzeige oder kostenloser Eintrag): Material und Bleigleichwert der günstigsten
   Konfiguration vorauswählen. Die Seite zeigt dann "ab X €", genau den Startpreis aus dem Google-Eintrag.
   Größe und Länge bleiben offen (Pflichtauswahl), damit niemand versehentlich die kleinste Größe bestellt.
   Alle anderen Besucher sehen die normale Voreinstellung. Läuft nach assets/mdx-konfigurator.js und
   bedient nur dessen Schaltflächen, die Konfigurator-Logik bleibt unverändert. */
(function () {
  var q;
  try { q = new URLSearchParams(window.location.search); } catch (e) { return; }
  var google = q.has('gclid') || q.has('gad_source') || q.has('gad_campaignid') || q.has('srsltid') || /google/i.test(q.get('utm_source') || '');
  if (!google) return;
  var root = document.querySelector('[data-mdx-konfig]'), dataEl = document.getElementById('mdx-konfig-data');
  if (!root || !dataEl) return;
  var D;
  try { D = JSON.parse(dataEl.textContent); } catch (e) { return; }
  var rows = D.rows || D.rock;
  if (!rows || !rows.length) return;
  // Zeile: [variantId, sku, preis, material, "0,25 / 0,35", "M / 65 cm"]
  var best = rows.reduce(function (a, r) { return r[2] < a[2] ? r : a; });
  var lead = String(best[4]).split(' / ');
  var want = { mat: best[3], front: lead[0].replace(',', '.'), back: (lead.length < 2 || /^kein/.test(lead[1])) ? null : lead[1].replace(',', '.') };
  function press(dim, val) {
    if (!val) return;
    var b = root.querySelector('button[data-dim="' + dim + '"][data-v="' + val + '"]');
    if (b && !b.disabled && b.getAttribute('aria-pressed') !== 'true') b.click();
  }
  // Nach jedem Klick baut der Konfigurator die Schaltflächen neu auf, deshalb wird jedes Mal neu gesucht.
  press('mat', want.mat);
  press('front', want.front);
  press('back', want.back);
})();
